var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-implantations';
                    var viewUrl = 'sprite.svg#view-icon-implantations';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-implantations#icon-implantations';
                            viewUrl = 'sprite.svg?icon-implantations#view-icon-implantations';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };